import React from "react"
import { SortIcon } from "components/Table_SortColumnIcon"

const webAlertsListColumns = () => {
  return [
    {
      text: "id",
      dataField: "id",
      sort: true,
      hidden: true,
      formatter: (cellContent, webAlert) => <>{webAlert.id}</>,
    },
    {
      text: "Title",
      dataField: "title",
      formatter: (cellContent, webAlert) => <>{webAlert.title}</>,
    },
    {
      text: "Text",
      dataField: "text",
      formatter: (cellContent, webAlert) => <>{webAlert.text}</>,
    },
    {
      text: "Type",
      dataField: "type",
      formatter: (cellContent, webAlert) => (
        <>
          {webAlert.type === 1 && "Release"}
          {webAlert.type === 2 && "Informative"}
        </>
      ),
    },
    {
      text: "Sent On",
      dataField: "created_at",
      sort: true,
      sortCaret: order => <SortIcon order={order} />,
      formatter: (cellContent, webAlert) => <>{webAlert?.created_at || "-"}</>,
    },
    {
      text: "User Name",
      dataField: "user.display_name",
      sort: true,
      sortCaret: order => <SortIcon order={order} />,
      formatter: (cellContent, webAlert) => <>{webAlert?.user?.display_name}</>,
    },
  ]
}

export default webAlertsListColumns
